import { Component, OnInit } from '@angular/core';

import { OnboardingService } from 'src/app/services/onboarding.service';
import { RejectDocumentReasonComponent } from '../../components/reject-document-reason/reject-document-reason.component';
import { ApproveDocumentReasonComponent } from '../../components/approve-document-reason/approve-document-reason.component';
import { UploadToRelayAlertComponent } from '../../components/upload-to-relay-alert/upload-to-relay-alert.component';
import { IngestionService } from 'src/app/services/ingestion.service';
import { DiaryModel } from 'src/app/models/diary.Model';
import { AuthService } from 'src/app/services/auth.service';
import { AgentModel } from 'src/app/models/agent.Model';
import { EmailValidator } from '@angular/forms';
import { OnboardingDocumentStatusModel } from 'src/app/models/emailCampaigns/onboardingDocumentStatus.Model';
import { ReviewedDocumentDetailModel } from 'src/app/models/emailCampaigns/reviewedDocumentDetail.Model';
import { ChillPushCampaignModel } from 'src/app/models/chillPushCampaign.Model';
import { BrokerService } from 'src/app/core/broker/broker.service';
import { CustomerDetails } from 'src/app/models/customerDetails.Model';
import { PDFDocumentProxy, PdfViewerModule } from 'ng2-pdf-viewer';
import { KeyValueModel } from 'src/app/models/keyValue.model';
import { LandingDetailPageEvent } from 'src/app/models/events/landingDetailPageEvent.model';
import { EventService } from 'src/app/services/event.service';
import { ReviewDocumentEvent } from 'src/app/models/events/reviewDocumentEvent.model';
import { DownloadPackEvent } from 'src/app/models/events/downloadPackEvent.model';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { AccordionModule } from 'primeng/accordion';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OverlappingSpinnerComponent } from '../../../shared/components/overlapping-spinner/overlapping-spinner.component';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-validate-diaries-page',
    templateUrl: './validate-diaries-page.component.html',
    styleUrls: ['./validate-diaries-page.component.sass'],
    imports: [AccordionModule, TooltipModule, ButtonModule, DialogModule, ProgressSpinnerModule, PdfViewerModule, OverlappingSpinnerComponent, TitleCasePipe]
})
export class ValidateDiariesPageComponent implements OnInit {
  panelOpenState = 0;
  pendingDiaryList: DiaryModel[] = [];
  toDoDiaryList: DiaryModel[] = [];
  reviewedDiaryList: DiaryModel[] = [];
  previewRotate: number = 0;
  pdfRotateAngle: number = 0;
  todoMenuLoading: boolean = true;
  agent!: AgentModel;

  diaryInPreview!: DiaryModel;
  pageInPreview: number = 0;
  previewLoading: boolean = false;
  diaryIdInPreview = '';
  documentNameInPreview = '';
  fileInPreview: any;
  textListInPreview!: KeyValueModel[];
  pdfInPreview!: any;
  fileTypeInPreview: string = '';

  isDownloadEnabled = false;
  isDownloadInProgress = false;

  zoom: number = 1;
  rotation: number = 0;
  pageNumber: number = 1;
  totalPage: number = 0;
  contentType: string = '';
  flip: number = 1;
  rotate: number = 0;

  /** Controls the inline error p-dialog (formerly a MatDialog TemplateRef). */
  showErrorDialog = false;

  public data: {
    policyCode: string;
    agentEmailAssigned: string;
    dateAssigned: any;
  };

  constructor(
    dialogConfig: DynamicDialogConfig,
    private onboardingService: OnboardingService,
    private eventService: EventService,
    private ingestionService: IngestionService,
    private brokerService: BrokerService,
    private authService: AuthService,
    private dialogService: DialogService,
    public dialogRef: DynamicDialogRef<ValidateDiariesPageComponent>
  ) {
    this.data = dialogConfig.data;
  }

  ngOnInit(): void {
    var user = this.authService.getUserDetail();

    this.agent = <AgentModel>{
      name: user?.name,
      email: user?.username,
    };

    // console.log(JSON.stringify(this.agent));

    this.ingestionService
      .getDiariesByPolicyCode(this.data.policyCode)
      .subscribe((res) => {
        this.toDoDiaryList = res.filter(
          (x: any) =>
            x.status.approved === false &&
            x.status.diaryOpen === true &&
            x.status.uploaded === true
        );

        this.todoMenuLoading = false;

        // console.log('TODO LIST => ');
        // console.warn(this.toDoDiaryList);

        this.pendingDiaryList = res.filter(
          (x: any) =>
            x.status.approved === false &&
            x.status.diaryOpen === true &&
            x.status.uploaded === false
        );

        // console.log('PENDING LIST => ');
        // console.warn(this.pendingDiaryList);

        this.reviewedDiaryList = res.filter(
          (x: any) => x.status.approved === true
        );
        debugger;
        let event = <LandingDetailPageEvent>{
          sessionId: sessionStorage.getItem('sessionId'),
          agent: <AgentModel>{
            name: user?.name,
            email: user?.username,
          },
          assignedEmail: this.data.agentEmailAssigned,
          assignedDate: this.data.dateAssigned,
          policyCode: this.data.policyCode,
          todoItems: <DiaryModel[]>this.toDoDiaryList,
          pendingItems: <DiaryModel[]>this.pendingDiaryList,
          approvedItems: this.reviewedDiaryList,
          datetime: new Date(),
        };

        this.eventService.landingDetailPageEvent(event);

        // console.log('Reviewed LIST => ');
        // console.warn(this.reviewedDiaryList);
      });
  }

  setStep(index: number) {
    this.panelOpenState = index;
  }

  resetPreviewVariables() {
    this.zoom = 1;
    this.rotation = 0;
    this.pageNumber = 1;
    this.totalPage = 0;
    this.contentType = '';
    this.flip = 1;
    this.rotate = 0;
  }

  getDocuments(diary: DiaryModel) {
    diary.agent = this.agent;

    this.resetPreviewVariables();
    this.previewLoading = true;
    this.textListInPreview = [];
    this.diaryIdInPreview = diary.id;
    this.documentNameInPreview = this.getDocumentName(diary.diaryTypeId);

    if (diary.docDetails[0].type == 'text') {
      this.textListInPreview = diary.docDetails[0].keyValues;

      if (
        diary.docDetails[0].value != '' &&
        diary.docDetails[0].value != null &&
        diary.docDetails[0].value != undefined
      ) {
        this.textListInPreview = this.textListInPreview || [];

        this.textListInPreview.push({
          key: 'item',
          value: diary.docDetails[0].value,
        });
      }
      this.pageInPreview = -1;
      this.fileTypeInPreview = 'text';

      this.diaryInPreview = diary;

      this.previewLoading = false;

      return;
    }

    if (diary.id !== this.diaryInPreview?.id) {
      this.resetRotate();
      this.pageInPreview = 0;
      this.fileInPreview = '';
    }

    this.onboardingService
      .getFile(diary.docDetails[this.pageInPreview])
      .subscribe(
        (res) => {
          if (res.type === 'application/pdf') {
            this.fileTypeInPreview = 'pdf';
            //this.previewImage = '../../../assets/images/Icon_pdf_file.svg';
            var tempBlob = new Blob([res], { type: res.type });
            var reader = new FileReader();
            reader.onload = () => {
              this.pdfInPreview = new Uint8Array(reader.result as ArrayBuffer);
            };
            reader.readAsArrayBuffer(tempBlob);
          } else {
            this.fileTypeInPreview = 'image';
            var reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onload = (_event) => {
              this.fileInPreview = reader.result;
            };
          }

          this.diaryInPreview = diary;
          this.previewLoading = false;
        },
        (error) => {
          // console.log('Fail');
          this.fileInPreview = undefined;
          this.previewLoading = false;
        }
      );
  }

  getItemName(text: string) {
    return text.match(/[A-Z]+(?![a-z])|[A-Z]?[a-z]+|\d+/g)?.join(' ');
  }

  getDocumentName(diaryId: string) {
    let documentName = '';

    switch (diaryId) {
      case '2T':
        documentName = 'IBAN';
        break;
      case '2C':
      case 'A4':
        documentName = 'No Claims Bonus';
        break;
      case '2E':
      case 'A2':
        documentName = 'Main Licence';
        break;
      case '2F':
      case 'A3':
        documentName = 'Additional Driver';
        break;
      case '2D':
      case 'A5':
        documentName = 'Letter(s) of Driving Experience';
        break;
      case '2I':
      case 'A0':
        documentName = 'Gap In Cover Letter';
        break;
      case '2A':
        documentName = 'Proposal Form';
        break;
      case '2J':
      case 'A7':
        documentName = 'NCT Certificate';
        break;
      case '2L':
      case 'F2':
        documentName = 'Engineers Report';
        break;
      case '2N':
      case 'J2':
        documentName = 'Irish Registration';
        break;
      case '2H':
      case '54':
        documentName = 'Valuation of Specified Item(s)';
        break;
      case '2B':
        documentName = 'Direct Debit Mandate';
        break;
      case '2O':
      case 'Z6':
        documentName = 'Proof of PPS';
        break;
      case '2P':
        documentName = 'Proof of Identification';
        break;
      case '9C':
        documentName = 'Commercial DDM';
        break;
      case '2S':
        documentName = 'Digital Journey';
        break;
      case '2U':
        documentName = 'Certificate Of Incorporation';
        break;
      case '2K':
      case 'A8':
        documentName = 'VLC';
        break;
      case '2Q':
        documentName = 'Proof Of Business Address';
        break;
      case '2V':
        documentName = 'Tax Registration Certificate';
        break;
      case '2R':
        documentName = 'Credit Worthiness Check';
        break;
      case '2G':
      case 'CD':
        documentName = 'TPP E-journey diary';
        break;
      case '1H':
        documentName = 'Marriage Certificate';
        break;
      case '18':
        documentName = "Doctor's letter / Medical report to confirm that you are fit to drive";
        break;
      case 'AF':
        documentName = 'Proof of 12 EDT Lessons being completed';
        break;
      case 'ZA':
        documentName = 'Mirrored No Claims Bonus';
        break;
      case 'AA':
        documentName = 'NCB Transfer Declaration';
        break;
      case 'CE':
        documentName = 'Premium Credit eJourney';
        break;
      case '21':
        documentName = 'Premium Credit Manual Documentation';
        break;
      case 'CF':
        documentName = 'Proof Of Address';
        break;
      default:
        documentName = 'Unknown document type';
        break;
    }
    return documentName;
  }

  rejectDocument() {
    this.diaryInPreview.title = this.documentNameInPreview;

    const dialogRef = this.dialogService.open(RejectDocumentReasonComponent, {
      width: '500px',
      modal: true,
      showHeader: false,
      closable: false,
      closeOnEscape: false,
    });

    dialogRef?.onClose.subscribe((result) => {
      if (result?.rejectReason?.length > 0) {
        this.diaryInPreview.reason = result.rejectReason;
        this.diaryInPreview.status.rejected = true;
        this.diaryInPreview.status.approved = false;
        this.diaryInPreview.status.uploaded = false;

        this.reviewDocumentEvent(this.diaryInPreview);
        // console.log(JSON.stringify(this.toDoDiaryList));
      }

      this.checkStatusDownloadButton();
    });
  }

  acceptDocument() {
    this.diaryInPreview.title = this.documentNameInPreview;

    const dialogRef = this.dialogService.open(ApproveDocumentReasonComponent, {
      width: '500px',
      modal: true,
      showHeader: false,
      closable: false,
      closeOnEscape: false,
    });

    dialogRef?.onClose.subscribe((result) => {
      if (result) {
        if (!result.approveReason) {
          this.diaryInPreview.reason = 'Document has been accepted.';
        } else {
          this.diaryInPreview.reason = result.approveReason;
        }

        this.diaryInPreview.status.approved = true;
        this.diaryInPreview.status.rejected = false;
        this.diaryInPreview.status.uploaded = true;

        this.reviewDocumentEvent(this.diaryInPreview);
        this.checkStatusDownloadButton();
      }
    });
  }

  reviewDocumentEvent(diary: DiaryModel) {
    var user = this.authService.getUserDetail();

    let event = <ReviewDocumentEvent>{
      sessionId: sessionStorage.getItem('sessionId'),
      diary: diary,
      assignedDate: this.data.dateAssigned,
      assignedEmail: this.data.agentEmailAssigned,
      eventTime: new Date(),
    };

    this.eventService.reviewDocumentEvent(event);
  }

  previousDocument() {
    this.resetRotate();
    this.pageInPreview--;
    this.getDocuments(this.diaryInPreview);
  }

  nextDocument() {
    this.resetRotate();
    this.pageInPreview++;
    this.getDocuments(this.diaryInPreview);
  }

  resetRotate() {
    this.previewRotate = 0;
    this.pdfRotateAngle = 0;
  }

  rotateToRight() {
    this.rotate += 90;
    this.previewRotate += 90;
    this.pdfRotateAngle += 90;
  }

  rotateToLeft() {
    this.rotate -= 90;
    this.previewRotate -= 90;
    this.pdfRotateAngle -= 90;
  }

  checkStatusDownloadButton() {
    let diaryWaitingReview = this.toDoDiaryList.filter((x) => !x.reason);

    // console.log(diaryWaitingReview?.length);

    if (diaryWaitingReview?.length == 0) this.isDownloadEnabled = true;
  }

  downloadNBPack() {

    this.isDownloadInProgress = true;

    let diaries: DiaryModel[] = [];

    // diaries.push(...this.toDoDiaryList);
    // diaries.push(
    //   ...this.pendingDiaryList.filter((x) => {
    //     x.title = this.getDocumentName(x.diaryTypeId);
    //     x.agent = this.agent;
    //   })
    // );
    // diaries.push(
    //   ...this.reviewedDiaryList.filter((x) => {
    //     x.title = this.getDocumentName(x.diaryTypeId);
    //     x.agent = this.agent;
    //   })
    // );

    this.pendingDiaryList.filter((x) => {
      x.title = this.getDocumentName(x.diaryTypeId);
      x.agent = this.agent;
      x.reason = 'Document is still outstanding';
      x.customerDetails = this.toDoDiaryList[0].customerDetails;
    });

    this.reviewedDiaryList.filter((x) => {
      x.title = this.getDocumentName(x.diaryTypeId);
      x.agent = this.agent;
      x.reason = 'Document has been accepted';
      x.customerDetails = this.toDoDiaryList[0].customerDetails;
    });

    diaries = this.toDoDiaryList.concat(
      this.pendingDiaryList,
      this.reviewedDiaryList
    );

    let event = <DownloadPackEvent>{
      sessionId: sessionStorage.getItem('sessionId'),
      diaries: diaries,
      eventTime: new Date(),
      assignedDate: this.data.dateAssigned,
      assignedEmail: this.data.agentEmailAssigned,
    };

    debugger;
    this.eventService.downloadPackEvent(event);

    this.ingestionService.saveDiaries(diaries).subscribe(
      (res) => {
        this.onboardingService.getNBPack(this.data.policyCode).subscribe(
          (res) => {
            const a = document.createElement('a');
            const objectUrl = URL.createObjectURL(res);
            a.href = objectUrl;
            a.download = `MyChillWF_${this.data.policyCode}_NBPACK`;
            a.click();
            URL.revokeObjectURL(objectUrl);
            // this.loadingDownloadNBPack = false;

            this.triggerCampaign(diaries);
            this.openUpdateToRelayAlert();

            this.isDownloadInProgress = false;
          },
          (error) => {
            this.isDownloadInProgress = false;
            this.openErrorMessageDialog();
            // console.log('NBPack creation error ' + error);
          }
        );
      },
      (error) => {
        this.isDownloadInProgress = false;
        this.openErrorMessageDialog();
        // console.log(error);
      }
    );
  }

  openUpdateToRelayAlert() {
    // console.log(JSON.stringify(this.agent));
    const dialogRef = this.dialogService.open(UploadToRelayAlertComponent, {
      modal: true,
      showHeader: false,
      closable: false,
      closeOnEscape: false,
    });
    dialogRef?.onClose.subscribe((result) => {
      if (result?.isUploadedToRelay) {
        this.dialogRef.close({
          isUploadedToRelay: result?.isUploadedToRelay,
        });
      }
    });
  }

  openErrorMessageDialog() {
    this.showErrorDialog = true;
  }

  triggerCampaign(diaries: DiaryModel[]) {
    var documentsReviewDetail: ReviewedDocumentDetailModel[] = <
      ReviewedDocumentDetailModel[]
      >diaries.map((x) => {
        var data = { name: x.title, msg: x.reason };

        return data;
      });

    var isSupportEmail = diaries[0]?.customerDetails?.supportEmail
    debugger
    let chillPushCampaign = <ChillPushCampaignModel>{}

    if (!isSupportEmail) {
      let onboardingCampaignParameter = <OnboardingDocumentStatusModel>{
        ProposerFirstName: diaries[0]?.customerDetails?.name,
        EmailAddress: diaries[0]?.customerDetails?.email,
        PolicyCode: diaries[0]?.policyCode,
        Docs: documentsReviewDetail,
      };

      chillPushCampaign.chillCampaignId = this.brokerService.current().campaigns.onboardingCampaignId;
      chillPushCampaign.parameters = onboardingCampaignParameter;
      chillPushCampaign.receivers = [diaries[0]?.customerDetails?.email];

    } else {
      chillPushCampaign.chillCampaignId = this.brokerService.current().campaigns.onboardingNoEmailCampaignId;
      chillPushCampaign.parameters = { diaries: diaries };
      chillPushCampaign.receivers = [this.brokerService.current().campaigns.ticketEmail];
    }


    this.ingestionService.sendCampaign(chillPushCampaign).subscribe(
      (res) => {
        // console.log(res);
        this.isDownloadInProgress = false;
      },
      (error) => {
        this.isDownloadInProgress = false;
        this.openErrorMessageDialog();
      }
    );
  }

  ///////////////////////////////
  zoomIn() {
    this.zoom += 0.5;
  }

  zoomOut() {
    this.zoom -= 0.5;
  }

  restoreZoom() {
    this.zoom = 1;
  }

  rotateLeft() {
    this.rotation -= 90;
  }

  rotateRight() {
    this.rotation += 90;
  }

  previousPage() {
    this.pageNumber -= 1;
  }

  nextPage() {
    this.pageNumber += 1;
  }

  mirror() {
    this.flip = this.flip * -1;
  }

  callback(pdf: PDFDocumentProxy) {
    // do anything with "pdf"

    this.totalPage = pdf.numPages;
  }
}
